var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "81px",
    viewBox: "0 0 88 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop-Certified-PRO-Web-content---2",
    transform: "translate(-761.000000, -677.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(761.000000, 677.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4369658,0.111511824 C16.9277344,0.111511824 12.4448564,4.55351351 12.4448564,9.9927935 L12.0815878,61.2252935 L17.5318138,61.2642884 L17.8952534,10.0128041 C17.8952534,7.55834671 19.9327386,5.56173775 22.4371368,5.56173775 L77.2123606,5.56173775 L77.2123606,0.111511824 L22.4369658,0.111511824 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2120186,0.111511824 C71.5019975,0.111511824 66.8564696,4.75686867 66.8564696,10.4670608 L66.8564696,67.9673121 C66.8564696,72.1240351 63.4736592,75.5068454 59.3169362,75.5068454 C55.1602133,75.5068454 51.7774029,72.1240351 51.7774029,67.9673121 L51.7774029,61.3361212 C51.7774029,59.8308826 50.557443,58.6109227 49.0522044,58.6109227 L2.72519848,58.6109227 C1.21995988,58.6109227 0,59.8308826 0,61.3361212 L0,67.9673121 C0,75.1298944 5.82717694,80.9570714 12.9897593,80.9570714 L12.9897593,75.5068454 C8.83218117,75.5068454 5.45022593,72.1240351 5.45022593,67.9673121 L5.45022593,64.0611486 L46.3271769,64.0611486 L46.3271769,67.967141 C46.3271769,75.1297234 52.1543539,80.9570714 59.3169362,80.9570714 C66.4795186,80.9570714 72.3066955,75.1297234 72.3066955,67.967141 L72.3066955,25.3643222 L84.8423691,25.3643222 C86.3476077,25.3643222 87.5675676,24.1443623 87.5675676,22.6391237 L87.5675676,10.4668898 C87.5675676,4.75686867 82.9222107,0.111511824 77.2120186,0.111511824 Z M82.1173416,19.9140963 L72.3068666,19.9140963 L72.3068666,10.4668898 C72.3068666,7.76170186 74.5078568,5.56173775 77.2120186,5.56173775 C79.9161803,5.56173775 82.1171706,7.76187289 82.1171706,10.4668898 L82.1171706,19.9140963 L82.1173416,19.9140963 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12.4446854,
    y: 75.5066744,
    width: 46.2355046,
    height: 5.45022593
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5136824,15.2813957 L26.4337753,15.2813957 C24.9285367,15.2813957 23.7085769,16.5013556 23.7085769,18.0065942 C23.7085769,19.5118328 24.9285367,20.7317927 26.4337753,20.7317927 L40.5136824,20.7317927 C42.018921,20.7317927 43.2388809,19.5118328 43.2388809,18.0065942 C43.2388809,16.5013556 42.01875,15.2813957 40.5136824,15.2813957 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8643602,26.1818476 L26.4337753,26.1818476 C24.9285367,26.1818476 23.7085769,27.4018074 23.7085769,28.907046 C23.7085769,30.4122846 24.9285367,31.6322445 26.4337753,31.6322445 L56.8643602,31.6322445 C58.3695988,31.6322445 59.5895587,30.4122846 59.5895587,28.907046 C59.5895587,27.4018074 58.3695988,26.1818476 56.8643602,26.1818476 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8643602,37.0822994 L26.4337753,37.0822994 C24.9285367,37.0822994 23.7085769,38.3022593 23.7085769,39.8074979 C23.7085769,41.3127365 24.9285367,42.5326964 26.4337753,42.5326964 L56.8643602,42.5326964 C58.3695988,42.5326964 59.5895587,41.3135916 59.5895587,39.8074979 C59.5895587,38.3022593 58.3695988,37.0822994 56.8643602,37.0822994 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8643602,47.9829223 L26.4337753,47.9829223 C24.9285367,47.9829223 23.7085769,49.2028822 23.7085769,50.7081208 C23.7085769,52.2133594 24.9285367,53.4333193 26.4337753,53.4333193 L56.8643602,53.4333193 C58.3695988,53.4333193 59.5895587,52.2133594 59.5895587,50.7081208 C59.5895587,49.2028822 58.3695988,47.9829223 56.8643602,47.9829223 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerms);
export default __webpack_public_path__ + "static/media/icon-terms.78581f2f5c6e6942fca8a89e5a234ffe.svg";
export { ForwardRef as ReactComponent };